import React from 'react';

import AltIso from 'alt/utils/AltIso';
import SeoActions from '../actions/SeoActions';

@AltIso.define((props) => {
    return SeoActions.pushTitle('Not found');
})

class NotFound extends React.Component {
    render() {
        return (
            <div className="maxwidth-wrapper">
                <h1>Page not found</h1>
            </div>
        );
    }
}

export default NotFound;



/** WEBPACK FOOTER **
 ** ./app/src/views/NotFound.js
 **/